import { render, staticRenderFns } from "./SalesData.vue?vue&type=template&id=ed955cf6&scoped=true"
import script from "./SalesData.vue?vue&type=script&lang=js"
export * from "./SalesData.vue?vue&type=script&lang=js"
import style0 from "./SalesData.vue?vue&type=style&index=0&id=ed955cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed955cf6",
  null
  
)

export default component.exports